import templateUrl from 'emun.on-demand/admin/design-publisher.htm'
import config from 'emun.on-demand/admin/_config'
import resolve from 'ioc/resolve'
import basicController from 'servicestack/basic.controller.properties'
import Design from 'emun.on-demand/lib/design'
import Media from 'webutils/media/media'
import ServiceBus from 'servicestack/service-bus'

let hasValue = m => !!m;

class DesignPublisherController {
    constructor($state,$stateParams) {
        basicController(this)
        const $ctrl = this;
        Object.assign($ctrl, {$state, $stateParams});
        $ctrl.bus = new ServiceBus();
        $ctrl.tagKinds = config.publishingGroups;
        $ctrl.publishingGroup = null;
        $ctrl.busy = 'Loading';
        let url = $ctrl.designId ? `QueryMedia/${$ctrl.designId}.json` : $ctrl.designEuid ? `QueryMedia/euid/${$ctrl.designEuid}.json` : null;
        //url += '?Fields=Id,Euid,Label,Tags,CreatedOn,Description,Height,Width,CreatedBy';
        let $design = $ctrl.bus.send(url).then(
            res => {
                $ctrl.busy = false; 
                $ctrl.design = new Design(res.data.results[0], false);
            },
            e => {$ctrl.busy = 'Design not found';}
        );
    }

    $onInit(){
        const $ctrl = this;
        $ctrl.select($ctrl.tagKinds[0]);
    }

    $onDestroy(){
        const $ctrl = this;
        $ctrl.bus.dispose();
    }

    register(publishingGroup) {
        const $ctrl = this;
        return $ctrl.publishingGroup = publishingGroup;
    }

    select(tagKind) {
        const $ctrl = this;
        return $ctrl.tagKind = tagKind;
    }

    img(size) {
        const $ctrl = this;
        return $ctrl.design.img(size);
    }

    toggle(g) {
        let $ctrl = this;
        $ctrl.publishingGroup.toggle(g);
    }

    analyze() {
        let $ctrl = this;
        $ctrl.publishingGroup.analyze();
    }

    publish(request) {
        let $ctrl = this;
        $ctrl.busy = 'Distributing design';
        
        return $ctrl.bus.send('CreateProductDesigns.json', request)
            .then(res => $ctrl.onPublsihed(res), res => $ctrl.onPublsihedFailed(res));
    }

    onPublsihed(res) {
        let $ctrl = this;
        $ctrl.$state.transitionTo("od-products.multi-view.grid", {designId:$ctrl.designId,recent:5,context:'publish'});
        $ctrl.onPublish();
    }

    onPublsihedFailed(res) {
        let $ctrl = this;
        $ctrl.busy = 'could not create products';
        console.error($ctrl.busy, res);
    }
}

let DesignPublisherComponent = {
    bindings: {
        designId: '@',
        onPublish: '&',
        onSaved: '&'
    },
    controller: DesignPublisherController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl;
    }
}

export default DesignPublisherComponent;